import { render, staticRenderFns } from "./quizModulePageNew2.vue?vue&type=template&id=779756ba&scoped=true&"
import script from "./quizModulePageNew2.vue?vue&type=script&lang=js&"
export * from "./quizModulePageNew2.vue?vue&type=script&lang=js&"
import style0 from "./quizModulePageNew2.vue?vue&type=style&index=0&id=779756ba&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "779756ba",
  null
  
)

export default component.exports